import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import React from 'react';
import Profile from "./pages/profile/Profile";
import Settings from "./pages/profile/Settings";
import WishList from "./pages/wishList/WishList";
import AcceptLink from "./pages/acceptlink/AcceptLink";
import AcceptInvite from "./pages/acceptInvite/AcceptInvite";
import CreateInvite from "./pages/createInvite/CreateInvite";
import Topbar from "./components/Topbar";
import Share from "./pages/sharepost/Share";
import Notifications from "./pages/notifications/Notifications";
import ConversationsPage from "./pages/messages/ConversationsPage";
import MessagesPage from "./pages/conversations/MessagesPage";
import ManageSubscription from "./pages/subscription/ManageSubscription";
import WriteIcon from "./components/share/writeIcon";
import ReactLoading from 'react-loading';
// import { getSessionId, startSession } from "./analytics/sessionId";
// import useIndexedDB from "./hooks/useIndexedDB";
import axios from 'axios';
import config from "./config";
import './App.css';

import {
  Routes,
  Route,
  Navigate, 
  useLocation,
} from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { AuthContext } from "./context/AuthContext";

function App() {
  const {isLoading, socket_context, user, } = useContext(AuthContext);
  const [socket, setSocket] = useState(null);
  const [unreadNotifications, setUnreadNotifications] = useState([]);
  const [readNotifications, setReadNotifications] = useState([]);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  // const [availableInvites, setAvailableInvites] = useState();
  const [activeConversationId, setActiveConversationId] = useState(null);
  const [unreadMessageConversationIcon, setUnreadMessageConversationIcon] = useState([]);
  const [lastMessage, setLastMessage] = useState();
  const [showTopbar, setShowTopbar] = useState(false);
  const [isAccountBalanceModalOpen, setIsAccountBalanceModalOpen] = useState(false);
  const location = useLocation();
  // const hasStartedSession = useRef(false);
  // getSessionId();

  const hideTopbar = 
    location.pathname === '/login';

  //  socket io for real-time notifications
  useEffect(() => {
    if (user && user._id && socket_context) {
      setSocket(socket_context);
      const handleGetNotification = (data) => {
        const { senderUserId, receiverUserId, linkOrWishlist, relatedPostId, amount, type, read, createdAt, ebItemPhoto, ebItemTitle, message } = data;
        
        // set notifications for real-time
        setUnreadNotifications((prev) => [
          {
            senderUserId,
            receiverUserId,
            linkOrWishlist,
            relatedPostId,
            amount,
            type,
            read,
            createdAt,
            ebItemPhoto,
            ebItemTitle,
            message
          },
          ...prev,
        ]);
      };

      const handleGetMessage = (newMessage) => {
        if (newMessage.conversationId !== activeConversationId){
          setUnreadMessageCount(prev => prev + 1 );
          setUnreadMessageConversationIcon((prev) => [newMessage.conversationId, ...prev]);
          setLastMessage(newMessage.text);
        }
      };
  
      socket_context.on("getNotification", handleGetNotification);
      socket_context.on("new-message", handleGetMessage);

      // Cleanup function
      return () => {
        socket_context.off("getNotification", handleGetNotification);
        socket_context.off("new-message", handleGetMessage);
      };

    }
      
  }, [user, socket_context, activeConversationId]);

    // Retrieve the user's notifications from the database
    useEffect(() => {
      if (user && user._id) {
        axios.get(`${config.apiUrl}/api/notifications/${user._id}`)
        .then((response) => {
          if (response.data.length > 0) {
            const unread = response.data.filter((notification) => notification.read == false);
            const read = response.data.filter((notification) => notification.read == true);
  
            setUnreadNotifications(unread);
            setReadNotifications(read);
          }
          })
          .catch(() => {
            console.log("whoops");
          });

          const token = localStorage.getItem("token");
          // New call to fetch count of unread messages
          axios.get(`${config.apiUrl}/messages/unread?userId=${user._id}`,{
            headers: {
              'x-auth-token': token,
            }
          })
          .then((response) => {
            // Assuming the backend sends back an object with unreadCount
            const unreadCount = response.data.unreadCount;
            setUnreadMessageCount(unreadCount);
          })
          .catch(() => {
            console.log("whoops");
          });
      }
    }, [user]);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10rem', marginBottom: '20px' }}>
        <ReactLoading type={'balls'} color={'white'} height={'20%'} width={'20%'} />
      </div>
    );
  }

  return (
      <>
      {!hideTopbar && 
        <Topbar 
        socket={socket}
        unreadNotifications={unreadNotifications} 
        unreadMessageCount={unreadMessageCount}
        // availableInvites={availableInvites}
        setShowTopbar={setShowTopbar}
        showTopbar={showTopbar}
        setIsAccountBalanceModalOpen={setIsAccountBalanceModalOpen}
        isAccountBalanceModalOpen={isAccountBalanceModalOpen}
        />
      }

      <div className="content-container">
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <>
                <WriteIcon />
                <Home socket={socket} user={user}/>
              </>
            }/>
            <Route 
              path="link/:linkCreatorUsername" 
              element={<AcceptLink 
                setShowTopbar={setShowTopbar}
                setIsAccountBalanceModalOpen={setIsAccountBalanceModalOpen}
                />} 
            />
            <Route path="/register" element={<Register />} />
            <Route path="share" element={user ? 
              <Share
                setShowTopbar={setShowTopbar}
                setIsAccountBalanceModalOpen={setIsAccountBalanceModalOpen}
              /> 
              : 
              <Navigate to="/login" />} 
            />
            <Route 
              path="/notifications" 
              element={user ? <Notifications 
                socket={socket} 
                setUnreadNotifications={setUnreadNotifications} unreadNotifications={unreadNotifications} setReadNotifications={setReadNotifications} readNotifications={readNotifications}/> 
              : <Navigate to="/login" />} 
            />
            <Route path="profile/:username" element={
              user ? (
                <>
                  <WriteIcon />
                  <Profile />
                </>
              ) : <Navigate to="/login" />
              }/>
            <Route path="profile/:username/settings" element={
              user ? <Settings/> : <Navigate to="/login" />}
            />
            <Route path="/wishlist/:username" element={
              <WishList 
                setShowTopbar={setShowTopbar}
                setIsAccountBalanceModalOpen={setIsAccountBalanceModalOpen}
              />} 
            />
            <Route path="/conversations" element={
              user ? <ConversationsPage
              socket={socket}
              user={user}
              setUnreadMessageConversationIcon={setUnreadMessageConversationIcon}
              unreadMessageConversationIcon={unreadMessageConversationIcon}
              lastMessage={lastMessage}
              /> 
              : <Navigate to="/login" />} 
            />
            <Route path="/messages/:conversationId" element={
              user ? <MessagesPage 
              socket={socket} 
              user={user} 
              setActiveConversationId={setActiveConversationId} 
              setUnreadMessageCount={setUnreadMessageCount}
              />
              : <Navigate to="/login" />} 
            />
            <Route path="/manage-subscription/:username" element={
              user ? <ManageSubscription /> : <Navigate to="/login" />} 
            />
            <Route path="/create-invite" element={
              user ? <CreateInvite /> : <Navigate to="/login" />} 
            />
            <Route path="/invites/accept/:inviteId" element={
              <AcceptInvite />} 
            />
          </Routes>
        </div>
      </>
  )
}

export default App;
